import { render } from "./OffertaTable.vue?vue&type=template&id=3b7a82cd&ts=true"
import script from "./OffertaTable.vue?vue&type=script&lang=ts"
export * from "./OffertaTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__